module.exports = __webpack_public_path__ + "img/pencilicon.d3032f26.svg";